import type { Ref } from "vue"
import type { ToastInstance } from "@/types/toast.interface"
import { ref } from "vue"

export class ToastScope {
  shared: boolean
  toasts: Ref<ToastInstance[]> = ref([])

  constructor(shared: boolean = false) {
    this.shared = shared
  }

  add(toast: ToastInstance): ToastInstance {
    this.toasts.value.push(toast)

    return toast
  }

  remove(toast: ToastInstance): void {
    const index = this.toasts.value.indexOf(toast)
    if (index > -1) {
      this.toasts.value.splice(index, 1)
    }
  }

  removeAll(groupId: string): void {
    this.toasts.value = this.toasts.value.filter(toast => toast.groupId !== groupId)
  }
}
